import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom"; // Import useNavigate for navigation
import axiosInstance from "../axiosInstance"; // Your axios instance for API requests
import Modal from "react-modal"; // Ensure react-modal is installed
import ItemComponentForCart from "../components/ItemComponetForCart";
import ViewCart from "../components/ViewCart";
import { useCart } from "../context/CartContext"; // Import the useCart hook
import { FaSpinner } from "react-icons/fa"; // Import the spinner icon
import { FaArrowUp } from "react-icons/fa";


// Set the app element for accessibility
Modal.setAppElement("#root"); // Adjust based on your app's root element

const OrderPage = () => {
  const { restaurantId, tableNumber } = useParams();
  const [menuItems, setMenuItems] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false); // State to control modal
  const [viewCartModalIsOpen, setViewCartModalIsOpen] = useState(false); // State to control view cart modal
  const [currentItem, setCurrentItem] = useState(null);
  const { state } = useCart(); // Get cart state from CartContext
  const [menuLoading, setMenuLoading] = useState(true); 
    const [showButton, setShowButton] = useState(false);

  // Utility function to set a cookie with expiration time
  const setCookie = (name, value, hours) => {
    const date = new Date();
    date.setTime(date.getTime() + hours * 60 * 60 * 1000); // 2 hours in milliseconds
    const expires = "expires=" + date.toUTCString();
    document.cookie = `${name}=${value}; ${expires}; path=/`;
  };

  useEffect(() => {
    // On component mount, store restaurantId and tableNumber in cookies for 2 hours
    if (restaurantId && tableNumber) {
      setCookie("restaurantId", restaurantId, 2); // Store restaurantId for 2 hours
      setCookie("tableNumber", tableNumber, 2); // Store tableNumber for 2 hours
    }
  }, [restaurantId, tableNumber]); // Runs when restaurantId or tableNumber changes

  
    useEffect(() => {
      const handleScroll = () => {
        if (window.scrollY > 300) {
          setShowButton(true);
        } else {
          setShowButton(false);
        }
      };
  
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
    // Scroll to top function
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };
  useEffect(() => {
    const fetchMenuItems = async () => {
      try {
        const response = await axiosInstance.get(
          `/api/menu-items?restaurantId=${restaurantId}`
        );
        setMenuItems(response.data); // Set the fetched menu items to state
        setMenuLoading(false);
      } catch (error) {
        console.error("Error fetching menu items:", error);
        setMenuLoading(false);
      }
    };

    fetchMenuItems();
  }, [restaurantId]);

  const openModal = (item) => {
    setCurrentItem(item); // Set the selected item
    setModalIsOpen(true); // Open the modal
  };

  const closeModal = () => {
    setModalIsOpen(false);
    setCurrentItem(null); // Reset selected item
  };

  // Group menu items by menuCategory and sort by priority
  const groupedMenuItems = menuItems.reduce((acc, item) => {
    const category = item.menuCategory;
    if (!category || !category.isVisible) return acc; // Skip invisible categories
    const key = category._id;
    if (!acc[key]) {
      acc[key] = {
        ...category,
        items: [],
      };
    }
    acc[key].items.push(item);
    return acc;
  }, {});

  console.log("Grouped Menu Items:", groupedMenuItems);

  const sortedCategories = Object.values(groupedMenuItems).sort(
    (a, b) => a.priority - b.priority
  );

  console.log("Sorted Categories:", sortedCategories);
  // Navigate to View Cart page
  const handleViewCart = () => {
    showViewCartModal();
  };

  const showViewCartModal = () => {
    setViewCartModalIsOpen(true);
  };

  const closeViewCartModal = () => {
    setViewCartModalIsOpen(false);
  };

  return (
    <div className="container mx-auto p-4 min-h-[800px]  ">
       {showButton && (
              <button
                onClick={scrollToTop}
                className="fixed bottom-5 left-5 p-3 rounded-full shadow-lg hover:opacity-90 transition-opacity"
                style={{
                  background: "linear-gradient(to right, #6A5ACD, #00BFFF)", // Gradient color
                  color: "white",
                  zIndex: 1000,
                }}
              >
                <FaArrowUp size={20} /> {/* FontAwesome arrow up icon */}
              </button>
            )}
      <div className="flex items-center justify-center">
        <h1 className="text-3xl font-extrabold mb-4 text-gray-800 tracking-wide relative">
          {/* Adding a decorative line and shadow for visual impact */}
          <span className="inline-block border-b-4 border-orange-500 pb-2 pr-2  ">
            Table {tableNumber}
          </span>
        </h1>
      </div>

      {menuLoading && (
        <div className="flex items-center justify-center h-64">
          <FaSpinner size={50} className="animate-spin text-gray-500" />
        </div>
      )}

      {/* Show View Cart button if there are items in the cart */}
      {state.items.length > 0 && !modalIsOpen && !viewCartModalIsOpen && (
        <button
          className="fixed bottom-6 right-4 bg-green-500 text-white py-2 px-4 rounded hover:bg-green-600 transition duration-200 z-20"
          onClick={handleViewCart}
        >
          View Cart ({state.items.length})
        </button>
      )}

      {sortedCategories?.map((category) => (
        <div key={category._id} className="mt-6">
          <h2 className="text-xl font-semibold text-yellow-800 mb-4">
            {category.name}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
            {category.items?.map((item) => (
              <div
                key={item._id}
                className={`bg-white shadow-md rounded-lg p-4 flex items-center transition-transform transform ${
                  !item.available
                    ? "opacity-50 cursor-not-allowed"
                    : "cursor-pointer hover:scale-105"
                }`}
                onClick={() => item.available && openModal(item)} // Open modal on item click only if available
              >
                {/* Not Available Message */}
                {!item.available && (
                  <div className="absolute top-2 left-2 bg-red-500 text-white text-xs font-semibold rounded px-2 py-1">
                    Not Available
                  </div>
                )}

                {/* Image on the left */}
                <div className="w-1/3 mr-4">
                  <img
                    src={item.imageUrl}
                    alt={item.name}
                    className="w-full h-24 object-cover rounded-md"
                  />
                </div>

                {/* Details on the right */}
                <div className="w-2/3">
                  <h4 className="text-lg text-gray-700 font-semibold">{item.name}</h4>
                  <p className="text-gray-600 text-sm">{item.description}</p>
                  <p className="text-xl text-gray-700 font-bold mt-2">${item.price}</p>
                </div>
              </div>
            ))}
          </div>
          <hr className="my-4" /> {/* Divider between categories */}
        </div>
      ))}

      {/* Modal for adding extras */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            padding: "20px",
            maxWidth: "300px",
            maxHeight: "600px",
            width: "100%",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
        }}
      >
        <ItemComponentForCart item={currentItem} closeModal={closeModal} />
      </Modal>
      <Modal
        isOpen={viewCartModalIsOpen}
        onRequestClose={closeViewCartModal}
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            padding: "20px",
            maxWidth: "300px",
            maxHeight: "600px",
            width: "100%",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
        }}
      >
        <ViewCart closeViewCartModal={closeViewCartModal} />
      </Modal>
    </div>
  );
};

export default OrderPage;
